import React, { useState } from 'react';

function ExciseAbatementPage1() {
  const params = new URLSearchParams(window.location.search);
  const town = params.get('town');
  const townCode = params.get('town_code');

  const [ownerName, setOwnerName] = useState('');
  const [billNumber, setBillNumber] = useState('');
  const [billYear, setBillYear] = useState(new Date().getFullYear().toString());
  const [plateNumber, setPlateNumber] = useState('');
  const [addressOnBill, setAddressOnBill] = useState('');
  const [mailingAddress, setMailingAddress] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  const handleContinue = (e) => {
    e.preventDefault();
    setError('');

    if (!ownerName || !billNumber || !billYear || !plateNumber || !addressOnBill || !phone || !email) {
      setError('Please fill in all required fields.');
      return;
    }

    const data = {
      town,
      townCode,
      ownerName,
      billNumber,
      billYear: parseInt(billYear),
      plateNumber,
      addressOnBill,
      mailingAddress: mailingAddress || null,
      phone,
      email,
    };

    sessionStorage.setItem('exciseAbatementPage1', JSON.stringify(data));
    window.location.href = `/excise-abatement-page2?town=${town}&town_code=${townCode}`;
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>

        {/* Header */}
        <div style={styles.header}>
          <h1 style={styles.title}>MAtownforms</h1>
          <div style={styles.stepRow}>
            <div style={styles.stepActive}>1 Filer Info</div>
            <div style={styles.stepLine}/>
            <div style={styles.stepInactive}>2 Reason & Sign</div>
          </div>
        </div>

        <p style={styles.meta}>Motor Vehicle Excise Abatement &nbsp;|&nbsp; {town}</p>
        <h2 style={styles.subtitle}>Step 1 — Filer Information</h2>
        <p style={styles.required}>* Required field</p>

        {error && <p style={styles.error}>{error}</p>}

        <form onSubmit={handleContinue}>

          <div style={styles.field}>
            <label style={styles.label}>Owner / Taxpayer Name as Shown on Bill *</label>
            <input style={styles.input} type="text" value={ownerName} onChange={e => setOwnerName(e.target.value)} required />
          </div>

          <div style={styles.row}>
            <div style={{ ...styles.field, flex: 1 }}>
              <label style={styles.label}>Bill Number *</label>
              <input style={styles.input} type="text" value={billNumber} onChange={e => setBillNumber(e.target.value)} required />
            </div>
            <div style={{ ...styles.field, flex: 1 }}>
              <label style={styles.label}>Bill Year *</label>
              <input style={styles.input} type="number" value={billYear} onChange={e => setBillYear(e.target.value)} min="2020" max="2030" required />
            </div>
          </div>

          <div style={styles.field}>
            <label style={styles.label}>License Plate *</label>
            <input style={styles.input} type="text" value={plateNumber} onChange={e => setPlateNumber(e.target.value.toUpperCase())} required />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Address as Shown on Bill *</label>
            <input style={styles.input} type="text" value={addressOnBill} onChange={e => setAddressOnBill(e.target.value)} required />
          </div>

          <div style={styles.field}>
            <label style={styles.label}>Current Mailing Address <span style={styles.hint}>(if different from above)</span></label>
            <input style={styles.input} type="text" value={mailingAddress} onChange={e => setMailingAddress(e.target.value)} />
          </div>

          <div style={styles.row}>
            <div style={{ ...styles.field, flex: 1 }}>
              <label style={styles.label}>Phone *</label>
              <input style={styles.input} type="tel" value={phone} onChange={e => setPhone(e.target.value)} required />
            </div>
            <div style={{ ...styles.field, flex: 1 }}>
              <label style={styles.label}>Email *</label>
              <input style={styles.input} type="email" value={email} onChange={e => setEmail(e.target.value)} required />
            </div>
          </div>

          <div style={styles.notice}>
            <strong>Important:</strong> Your excise bill must be paid before this abatement can be processed, even if you believe you are entitled to an abatement. No abatement of less than $5 will be made.
          </div>

          <button style={styles.button} type="submit">Continue →</button>

        </form>

        <p style={styles.backLink}>
          <a href={`/form-select?town=${town}&town_code=${townCode}`} style={styles.anchor}>← Back</a>
        </p>

      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#f4f6f9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 20px',
  },
  card: {
    backgroundColor: '#ffffff',
    padding: '40px',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    width: '100%',
    maxWidth: '560px',
  },
  header: {
    marginBottom: '16px',
  },
  title: {
    color: '#1a3a5c',
    fontSize: '42px',
    fontWeight: '700',
    fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif',
    marginBottom: '16px',
    textAlign: 'center',
  },
  stepRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    marginBottom: '8px',
  },
  stepActive: {
    backgroundColor: '#1a3a5c',
    color: '#fff',
    padding: '4px 14px',
    borderRadius: '20px',
    fontSize: '13px',
    fontWeight: '600',
  },
  stepLine: {
    width: '40px',
    height: '2px',
    backgroundColor: '#ccc',
  },
  stepInactive: {
    backgroundColor: '#eee',
    color: '#999',
    padding: '4px 14px',
    borderRadius: '20px',
    fontSize: '13px',
  },
  meta: {
    textAlign: 'center',
    fontSize: '13px',
    color: '#666',
    marginBottom: '8px',
  },
  subtitle: {
    color: '#1a3a5c',
    fontSize: '18px',
    marginBottom: '4px',
    textAlign: 'center',
  },
  required: {
    fontSize: '12px',
    color: '#888',
    textAlign: 'right',
    marginBottom: '16px',
  },
  field: {
    marginBottom: '16px',
  },
  row: {
    display: 'flex',
    gap: '16px',
    marginBottom: '0',
  },
  label: {
    display: 'block',
    fontSize: '14px',
    fontWeight: '600',
    color: '#333',
    marginBottom: '6px',
  },
  hint: {
    fontSize: '12px',
    fontWeight: '400',
    color: '#888',
  },
  input: {
    width: '100%',
    padding: '10px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    fontSize: '14px',
    boxSizing: 'border-box',
  },
  notice: {
    backgroundColor: '#fff8e1',
    border: '1px solid #ffe082',
    borderRadius: '4px',
    padding: '12px',
    fontSize: '13px',
    color: '#555',
    marginBottom: '20px',
    lineHeight: '1.5',
  },
  button: {
    width: '100%',
    padding: '12px',
    backgroundColor: '#1a3a5c',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    cursor: 'pointer',
    marginBottom: '16px',
  },
  error: {
    color: '#cc0000',
    fontSize: '14px',
    marginBottom: '16px',
    textAlign: 'center',
  },
  backLink: {
    textAlign: 'center',
    fontSize: '14px',
  },
  anchor: {
    color: '#1a3a5c',
    fontWeight: '600',
  },
};

export default ExciseAbatementPage1;